export const DomPurifyConfig = {
  ALLOWED_ATTR: ['class'],
  ALLOWED_TAGS: ['b', 'br', 'blockquote', 'em', 'li', 'ol', 'p', 'pre', 'span', 'strong', 'ul'],
};
